import axios from 'axios'
import { ICharts } from '../../types/charts/ICharts'

const BASE_URL = process.env.REACT_APP_API

const api = axios.create({
  baseURL: BASE_URL,
})

async function getCharts() {
  const chartsDeezer: ICharts[] = []

  const res = await api.get('charts')
  chartsDeezer.push(res.data)

  return chartsDeezer[0]
}

export { getCharts, api }
